import { Navigate, Outlet } from "react-router-dom";

const AdminRoutes = ({ isAuth, isAdmin }) => {
    if (!isAuth) {
        return <Navigate to="/login" />;
    }
    if (isAuth && !isAdmin) {
        return <Navigate to="/" />;
    }

    return <Outlet />;
};

export default AdminRoutes;
